const STORAGE_KEY = "omelink-uploading-messages";

// 从 localStorage 加载数据
const loadFromStorage = () => {
	try {
		const data = localStorage.getItem(STORAGE_KEY);
		return data ? JSON.parse(data) : {};
	} catch (error) {
		return {};
	}
};

// 保存到 localStorage
const saveToStorage = (messages) => {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(messages));
	} catch (error) {
		console.error(error);
	}
};

const uploadingMessages = {
	namespaced: true, // 开启命名空间

	state: {
		messages: loadFromStorage(), // 初始化时从 localStorage 加载
	},

	mutations: {
		// 添加上传中的消息
		ADD_MESSAGE(state, { id, message, conversationObjectId, fileUploaded = false }) {
			state.messages = {
				...state.messages,
				[id]: {
					message,
					conversationObjectId,
					startTime: Date.now(),
					fileUploaded,
				},
			};
			saveToStorage(state.messages);
		},
		// 标记文件已上传OSS
		MARK_FILE_UPLOADED(state, id) {
			if (state.messages[id]) {
				state.messages[id].fileUploaded = true;
				state.messages[id].message._fileUploaded = true;
				saveToStorage(state.messages);
			}
		},
		REMOVE_MESSAGE(state, id) {
			const { [id]: removed, ...rest } = state.messages;
			state.messages = rest;

			saveToStorage(state.messages);
		},

		UPDATE_MESSAGE_STATUS(state, { id, status }) {
			if (state.messages[id]) {
				state.messages[id].message._status = status;

				saveToStorage(state.messages);
			}
		},

		// 清理超时的上传消息 (默认30分钟)
		CLEAN_TIMEOUT_MESSAGES(state, timeout = 30 * 60 * 1000) {
			const now = Date.now();
			const validMessages = {};

			Object.entries(state.messages).forEach(([id, item]) => {
				if (now - item.startTime < timeout) {
					validMessages[id] = item;
				}
			});

			state.messages = validMessages;

			saveToStorage(state.messages);
		},

		// 页面刷新后,将所有上传中的消息标记为失败
		MARK_ALL_AS_FAILED(state) {
			Object.keys(state.messages).forEach((id) => {
				if (state.messages[id].message._status === 0) {
					state.messages[id].message._status = 2; // 标记为失败
				}
			});

			saveToStorage(state.messages);
		},

		// 清空所有上传消息
		CLEAR_ALL(state) {
			state.messages = {};
			localStorage.removeItem(STORAGE_KEY);
		},
	},

	getters: {
		// 根据对话 object_id 获取上传中的消息
		getMessagesByConversation: (state) => (objectId) => {
			return Object.values(state.messages)
				.filter((item) => item.conversationObjectId === objectId)
				.map((item) => item.message);
		},

		// 获取所有上传中的消息数量
		getTotalCount: (state) => {
			return Object.keys(state.messages).length;
		},
	},
};

export default uploadingMessages;
